exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?minimize!vue-wysiwyg/dist/vueWysiwyg.css"), "");

// module
exports.push([module.id, ".fts-form-designer .form-designer-footer{padding-top:1.5rem;border-top:1px solid var(--fts-border)}.fts-form-designer .automation-design-content{margin-top:1rem}", ""]);

// exports
